import {clsx} from 'clsx'
import type {ReactNode} from 'react'

import styles from './WithShimmerEffect.module.css'

interface WithShimmerEffectProps {
  children: ReactNode
  className?: string
  innerClassName?: string
  as?: 'div' | 'span'
}

export const WithShimmerEffect = ({
  children,
  className,
  innerClassName,
  as: Component = 'div',
}: WithShimmerEffectProps) => {
  return (
    <Component className={clsx(styles.fadeIn, className)}>
      <Component className={clsx(styles.shimmerText, innerClassName)}>{children}</Component>
    </Component>
  )
}
